import AuthApi from '../api'

export const login = async ({ commit }, payload) => {
  commit('UPDATE_IS_LOADING', true)
  commit('SET_ERROR', '')
  let response = await AuthApi.login(payload)
  if (response.success) {
    commit('SET_LOGGED_IN', true)
    commit('UPDATE_TOKEN', response.token)
  } else {
    commit('SET_ERROR', response.error)
  }
  commit('UPDATE_IS_LOADING', false)
}
export const setIsLoading = ({ commit }, payload) => {
  commit('UPDATE_IS_LOADING', payload)
}
export const setError = ({ commit }, payload) => {
  commit('SET_ERROR', payload)
}

export const register = async ({ commit }, payload) => {
  commit('UPDATE_IS_LOADING', true)
  commit('SET_ERROR', '')
  let response = await AuthApi.register(payload)
  if (!response.success) {
    commit('SET_ERROR', response.error)
  }
  commit('UPDATE_IS_LOADING', false)
}
